import { jsx, jsxs } from "react/jsx-runtime";
import { Card, CardContent } from "./card.js";
import { Button } from "./button.js";
import { Calendar, X } from "lucide-react";
import { useState } from "react";
function DateRangePicker({
  dateRange,
  onDateRangeChange,
  onClose,
  labels = {}
}) {
  const [tempRange, setTempRange] = useState(dateRange);
  const quickRanges = [
    {
      label: labels.last7Days || "Last 7 days",
      getValue: () => ({
        from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
        to: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
      })
    },
    {
      label: labels.last30Days || "Last 30 days",
      getValue: () => ({
        from: new Date(Date.now() - 30 * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
        to: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
      })
    },
    {
      label: labels.last90Days || "Last 90 days",
      getValue: () => ({
        from: new Date(Date.now() - 90 * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
        to: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
      })
    },
    {
      label: labels.thisMonth || "This month",
      getValue: () => {
        const now = /* @__PURE__ */ new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        return {
          from: firstDay.toISOString().split("T")[0],
          to: now.toISOString().split("T")[0]
        };
      }
    },
    {
      label: labels.lastMonth || "Last month",
      getValue: () => {
        const now = /* @__PURE__ */ new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);
        return {
          from: firstDay.toISOString().split("T")[0],
          to: lastDay.toISOString().split("T")[0]
        };
      }
    },
    {
      label: labels.allTime || "All time",
      getValue: () => ({
        from: new Date(Date.now() - 365 * 24 * 60 * 60 * 1e3).toISOString().split("T")[0],
        to: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
      })
    }
  ];
  const handleApply = () => {
    onDateRangeChange(tempRange);
  };
  return /* @__PURE__ */ jsx(Card, { className: "w-[360px] border-border/40 shadow-lg", children: /* @__PURE__ */ jsxs(CardContent, { className: "p-0", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between px-4 py-3 border-b border-border/40", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(Calendar, { className: "h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: labels.title || "Select date range" })
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: onClose,
          className: "h-7 w-7 p-0",
          children: /* @__PURE__ */ jsx(X, { className: "h-4 w-4" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "p-3 border-b border-border/40", children: /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-2", children: quickRanges.map((range, idx) => /* @__PURE__ */ jsx(
      Button,
      {
        variant: "outline",
        size: "sm",
        onClick: () => {
          const newRange = range.getValue();
          setTempRange(newRange);
        },
        className: "justify-start text-xs font-normal h-8",
        children: range.label
      },
      idx
    )) }) }),
    /* @__PURE__ */ jsxs("div", { className: "p-4 space-y-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ jsx("label", { className: "text-xs font-medium text-muted-foreground", children: labels.from || "From" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "date",
            value: tempRange.from,
            onChange: (e) => setTempRange({ ...tempRange, from: e.target.value }),
            className: "w-full px-3 py-1.5 text-sm rounded-md border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/20"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ jsx("label", { className: "text-xs font-medium text-muted-foreground", children: labels.to || "To" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "date",
            value: tempRange.to,
            onChange: (e) => setTempRange({ ...tempRange, to: e.target.value }),
            className: "w-full px-3 py-1.5 text-sm rounded-md border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/20"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-end gap-2 px-4 py-3 border-t border-border/40 bg-muted/20", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: onClose,
          className: "text-xs",
          children: labels.cancel || "Cancel"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "sm",
          onClick: handleApply,
          className: "gap-2 !bg-primary !text-primary-foreground hover:!bg-primary/90 text-xs",
          children: labels.apply || "Apply"
        }
      )
    ] })
  ] }) });
}
export {
  DateRangePicker
};
//# sourceMappingURL=date-range-picker.js.map
